import { AddressesLibrary } from '@/components/addresses/AddressesLibrary';

export default function AddressesPage() {
  return (
    <div className="container mx-auto max-w-7xl">
      <AddressesLibrary />
    </div>
  );
}
